"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const antd_1 = require("antd");
class SmartTabs extends React.Component {
    constructor() {
        super(...arguments);
        this.renderDesktopContent = (tabs) => {
            return tabs
                .filter(tab => !tab.hidden)
                .map(tab => (React.createElement(antd_1.Tabs.TabPane, { key: tab.key, tab: tab.title }, tab.content)));
        };
    }
    render() {
        const { activeKey, onChange, defaultActiveKey, className } = this.props;
        const tabs = this.props.tabs.filter(tab => !tab.hidden);
        const wrapperClasses = `${className}` || '';
        return activeKey ? (React.createElement("div", { className: wrapperClasses },
            React.createElement(antd_1.Tabs, { activeKey: activeKey, defaultActiveKey: defaultActiveKey, onChange: onChange, tabBarStyle: { textAlign: 'center' } }, this.renderDesktopContent(tabs)))) : (React.createElement("div", { className: wrapperClasses },
            React.createElement(antd_1.Tabs, { defaultActiveKey: defaultActiveKey, onChange: onChange, tabBarStyle: { textAlign: 'center' } }, this.renderDesktopContent(tabs))));
    }
}
exports.SmartTabs = SmartTabs;
//# sourceMappingURL=SmartTabs.js.map